module.exports = __webpack_public_path__ + "img/128.f00f9d38.jpg";